// import React, { useState } from 'react';
import React, { useMemo } from 'react';
import { v4 as uuidV4 } from 'uuid';

import PerformanceImageGallery from '../../components/PerformanceImageGallery/PerformanceImageGallery';

import { PerformanceStyle } from './PerformanceStyle';

const Performance = () => {
  // const [images, setImages] = useState([]);

  const images = useMemo(() => {
    const currentImages = [];

    for (let i = 1; i <= 321; i += 1) {
      let maskFile = '';

      if (i - 1 < 10) {
        maskFile = `transparent_slice_0000${i - 1}`;
      } else if (i - 1 < 100) {
        maskFile = `transparent_slice_000${i - 1}`;
      } else if (i - 1 < 1000) {
        maskFile = `transparent_slice_00${i - 1}`;
      }

      // const base = `${process.env.PUBLIC_URL}/images`;
      const base = 'https://projetos.grama.cc/healthscan';

      currentImages.push({
        id: uuidV4(),
        original: `${base}/original/${i}.png`,
        classificated: `${base}/classificated/${i}.png`,
        mask: `${base}/mask/${maskFile}.png`,
      });
    }

    return currentImages;
  }, []);

  return (
    <PerformanceStyle>
      <PerformanceImageGallery images={images} />
    </PerformanceStyle>
  );
};

export default Performance;
